import { useCartStore } from "../cartStore";
import { useEffect, useState } from "react";

function Stepper({ productId, min = 1, max = 10 }) {
  const { cart, updateProductQuantity } = useCartStore();
  
  // Estado local temporal para asegurar que el cambio se refleje
  const [count, setCount] = useState(min);

  // Efecto para sincronizar cambios con el estado global
  useEffect(() => {
    const productInCart = cart.find((item) => item.id === productId);
    if (productInCart) {
      setCount(productInCart.quantity);
    }
  }, [cart, productId]);

  const decrease = () => {
    if (count > min) {
      const newCount = count - 1;
      setCount(newCount);
      updateProductQuantity(productId, newCount);
    }
  };

  const increase = () => {
    if (count < max) {
      const newCount = count + 1;
      setCount(newCount);
      updateProductQuantity(productId, newCount);
    }
  };

  const handleChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value) && value >= min && value <= max) {
      setCount(value);
      updateProductQuantity(productId, value);
    }
  };

  return (
    <div className="flex text-right">
      <input
        type="number"
        value={count}
        onChange={handleChange}
        className="form-control text-center"
      />
      <button 
        onClick={decrease} 
        className="btn btn-green btn-sm" 
        disabled={count === min}
      >
        -
      </button>
      <button 
        onClick={increase} 
        className="btn btn-green btn-sm ml-2" 
        disabled={count === max}
      >
        +
      </button>
    </div>
  );
}

export default Stepper;
